import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Advantage from "../views/Advantage.vue";
import Partners from "../views/Partners.vue";
import Contact from "../views/Contact.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/beneficios",
    name: "Advantage",
    component: Advantage,
  },
  {
    path: "/parceiros",
    name: "Partners",
    component: Partners,
  },
  {
    path: "/contato",
    name: "Contact",
    component: Contact,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
      // return window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
});

export default router;
